module.exports = __webpack_public_path__ + "static/img/importexport.b85712c7.png";